import React from 'react';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function VerticalToggleButtons(props) {
  const user = JSON.parse(localStorage.getItem('user'));
  const enableBundle = !user?.features?.extra;
  return (
    <ToggleButtonGroup className="mt-4" value={props.view} exclusive>
      <ToggleButton
        value="list"
        aria-label="list"
        onClick={props.setList}
        className="flex items-center"
      >
        <ViewListIcon className="mr-2" />
        List
      </ToggleButton>
      <ToggleButton
        value="module"
        aria-label="module"
        onClick={props.setModule}
        className="flex items-center"
      >
        <ViewModuleIcon className="mr-2" />
        Products
      </ToggleButton>
      {enableBundle && (
        <ToggleButton
          value="bundle"
          aria-label="bundle"
          onClick={props.setBundles}
          className="flex items-center"
        >
          <ViewModuleIcon className="mr-2" />
          Bundles
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  );
}
